import { Injectable } from '@angular/core';
import {
  LOGIN_API_URL,
  LOGIN_MICROSOFT_API_URL,
  LOGIN_SSO_URL,
  CONSENT,
  ORIGIN,
} from 'src/app/shared/api.constant';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SsoService } from 'src/app/core/services/sso.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root',
})
export class LoginService {
  isEnableCaptcha = environment.enableCaptcha;
  formGroup!: FormGroup;
  constructor(
    private readonly ssoService: SsoService,
    private readonly formBuilder: FormBuilder
  ) {}

  login(req: any) {
    return this.ssoService.post(LOGIN_API_URL + `?origin=${ORIGIN}`, req);
  }

  loginWithMicrosoft(req: any) {
    return this.ssoService.post(LOGIN_MICROSOFT_API_URL, req);
  }
  loginSSO(token?: string) {
    return this.ssoService.get(LOGIN_SSO_URL);
  }

  consentAgree(body: any) {
    return this.ssoService.post(CONSENT + `?origin=${ORIGIN}`, body);
  }

  getLoginFormGroup() {
    this.formGroup = this.formBuilder.group({
      useremail: [
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ]),
      ],
      userpassword: ['', Validators.required],
      rememberMe: [false],
      captcha: [''],
    });
    if (this.isEnableCaptcha) {
      this.formGroup.get('captcha')?.setValidators(Validators.required);
      this.formGroup.get('captcha')?.updateValueAndValidity();
    }

    return this.formGroup;
  }
}
